import { dom } from "@omegagrid/core";
import { FormContainer } from "@omegagrid/form";
import rp, { SyncEditorAdapter, SyncEditorOptions, SyncFormAdapter } from "@reporting/rp-app-host";
import { AccountingTreeAdapter } from "@reporting/rp-mf-accounting";
import { ObjectShare } from "@reporting/rp-types/core";

/**
 * The synchronization of the company wiki into other companies (P_OBJECT_SHARE, the whole wiki is the
 * object), as ETL and MDM have it: the pages and files are copied into the target company - the ones
 * marked out of synchronization (the page form) stay out, and in the target company they survive the
 * copy. No sharing in place: a registration lives in the master database of this company, and a company
 * on another master database would never see it.
 */
export class WikiSyncEditorAdapter extends SyncEditorAdapter {

	/** the calls name the company: the wiki service takes accounting 0 for the application wiki, which registers nothing */
	private get a() { return rp.accountingProvider.a; }

	async delete(idz: number) {
		await rp.ms('wiki').delete(`sync/objects/${idz}`, { accounting: this.a });
	}

	async synchronize() {
		await rp.ms('wiki').get('sync', { accounting: this.a });
	}

	async getEditFormComponent(idz: number): Promise<HTMLElement> {
		const component = dom.createElement<FormContainer>('og-form-container');
		component.adapter = new SyncFormAdapter(
			rp.ms('wiki'),
			[{
				key: 'accounting_share',
				// every company the user may see but this one, as a tree by groups
				getSourceData: () => new AccountingTreeAdapter({ excludedAccounting: this.a, byGroups: true }).getTree(),
			}],
			idz
		);
		return component;
	}

	async getObjects(): Promise<ObjectShare[]> {
		return await rp.ms('wiki').get<ObjectShare[]>('sync/objects', { accounting: this.a });
	}

	getOptions(): Partial<SyncEditorOptions> {
		return this.createOptions({
			listItemFields: ['company', 'date_created', 'who_created'],
			columns: ['company', 'date_created', 'who_created'], // the object is the whole wiki
		});
	}

}
